import { render } from "./Contenteditable.vue?vue&type=template&id=4cfd519b"
import script from "./Contenteditable.vue?vue&type=script&lang=js"
export * from "./Contenteditable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__